import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardCartAndSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/dashboard-cart-and-settings';
import { AppModules } from '@common-modules/shared/app-modules.enum';

const COMPONENT_SELECTOR = 'ct-create-dashboard-widget-popup';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './create-dashboard-widget-popup.component.html',
  styleUrl: './create-dashboard-widget-popup.component.scss',
  standalone: false,
})
export class CreateDashboardWidgetPopupComponent {
  readonly T_SCOPE = `${AppModules.RightPanel}.${COMPONENT_SELECTOR}`;
  readonly titleKey = `${this.T_SCOPE}.title`;

  constructor(private readonly _dialogRef: MatDialogRef<CreateDashboardWidgetPopupComponent>) {}

  onCartSelectionSubmit(cartSelection: DashboardCartAndSettings): void {
    this._dialogRef.close(cartSelection);
  }

  cancel(event): void {
    this._dialogRef.close();
  }
}
